import { ShieldAlert } from "lucide-react";
import { useTranslation } from "react-i18next";

import { Empty } from "@/components/shared";
import { useCan } from "@/hooks";
import type { ChildrenProps } from "@/types/props";

/**
 * Marshrutni ruxsat bilan yopadi.
 *
 * Qayta yo'naltirish EMAS, xabar: manzilni yozib qo'ygan yoki havola
 * olgan odam nima uchun kira olmayotganini bilishi kerak. Jimgina
 * dashboard'ga tashlash "havola ishlamadi" degan taassurot qoldiradi.
 *
 * Bu — interfeys qorovuli. Haqiqiy cheklov backendda: bu sahifa ochilsa
 * ham, uning har bir so'rovi 403 bilan qaytadi.
 */
export function RequirePermission({
  permission,
  children,
}: ChildrenProps & { permission: string }) {
  const { t } = useTranslation();
  const { can } = useCan();

  if (!can(permission)) {
    return (
      <Empty
        icon={ShieldAlert}
        title={t("auth.forbiddenTitle")}
        description={t("auth.forbiddenHint")}
      />
    );
  }

  return <>{children}</>;
}
